<template>
  <div>
    <div class="" v-if="Object.keys(newValue).length > 0">
      <div class="flex flex-wrap">
        <span
          class="mr-2 mb-2 flex items-baseline justify-between rounded bg-gray-100 px-4 py-3 print:p-0"
          v-for="{ id, name, isStandIn } in filteredRoles"
          :key="id"
        >
          <h5 class="font-semibold">
            {{ name }}
          </h5>
          <span class="ml-4 text-sm text-gray-500" v-if="isStandIn">
            {{ $t('global.as_stand_in') }}
          </span>
          <span
            class="far fa-times ml-4 cursor-pointer p-1 hover:text-brand-500"
            @click="remove(id)"
          ></span>
        </span>
      </div>
    </div>
    <div class="flex flex-col sm:flex-row" v-if="availableRoles">
      <div class="flex">
        <role-input class="flex-1 border-b-0" v-model="addRoleId" :options="options"></role-input>
        <label
          class="flex items-center rounded-r rounded-b-none border-t border-r pl-2 pr-4 text-sm text-gray-600 sm:rounded-r-none sm:border-b sm:border-r-0"
          v-if="withStandIn"
        >
          <input type="checkbox" v-model="addAsStandIn" class="mr-1" />
          {{ $t('global.as_stand_in') }}
        </label>
      </div>
      <button
        type="button"
        class="btn btn-outline-primary rounded-t-none sm:rounded-r sm:rounded-l-none"
        :disabled="!addRoleId"
        @click="add"
      >
        {{ $t('global.add') }}
      </button>
    </div>
    <p class="mt-1 px-1 text-sm text-gray-500">
      {{ $t('global.role_explanation') }}
    </p>
    <input
      type="hidden"
      v-for="(isStandIn, id, idx) in newValue"
      :key="id"
      :name="'group_roles[' + idx + '][id]'"
      :value="id"
    />
    <input
      type="hidden"
      v-for="(isStandIn, id, idx) in newValue"
      :key="id"
      :name="'group_roles[' + idx + '][is_stand_in]'"
      :value="isStandIn ? 1 : 0"
    />
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
    withStandIn: {
      required: false,
      default: true,
    },
  },
  computed: {
    availableRoles() {
      return this.options
    },
    filteredRoles() {
      return this.options
        .filter(({ id }) => this.newValue[id] !== undefined)
        .map((option) => ({ ...option, isStandIn: this.newValue[option.id] }))
    },
  },
  methods: {
    add() {
      const data = this.newValue || {}
      data[this.addRoleId] = this.addAsStandIn

      this.newValue = data
      this.addRoleId = null
    },
    remove(id) {
      const data = this.newValue || {}
      delete data[id]

      this.newValue = data
    },
  },
  data() {
    return {
      newValue: {},
      addRoleId: null,
      addAsStandIn: false,
    }
  },
  mounted() {
    if (this.value instanceof Array) {
      this.newValue = {}
      for (const idx in this.currentRoles) {
        this.newValue[this.currentRoles[idx]] = false
      }
    } else {
      this.newValue = this.value
    }
  },
}
</script>
